<div class="m-5" *ngIf="thereIsData; else noData">
  <ng-content></ng-content>
</div>
<ng-template #noData>
  <div class="m-5 text-center">
    <p class="c-no-data-block__text c-no-data-block__text--gray">
      No hay datos que mostrar
    </p>
  </div>
</ng-template>